// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"244226f5","477":"75ad70af"}[chunkId] + ".chunk.js";
};